import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ArcElement, Chart, DoughnutController, Tooltip } from "chart.js";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { LosService } from "../../_LOS/services/los.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
declare var $: any;

@Component({
  selector: "app-new-quickloan-cibil-report-view",
  templateUrl: "./new-quickloan-cibil-report-view.component.html",
  styleUrls: ["./new-quickloan-cibil-report-view.component.scss"],
  standalone: false
})
export class NewQuickloanCibilReportViewComponent implements OnInit, AfterViewInit {
  // Demo data integrated from your JSON
  cibilData: any = {
    controlData: {
      success: true,
    },
    consumerCreditData: [
      {
        tuefHeader: {
          headerType: "TUEF",
          version: "12",
          memberRefNo: "APJPR04906",
          enquiryMemberUserId: "NB93329898_CIRC2CNPE",
          subjectReturnCode: 1,
          enquiryControlNumber: "009690509047",
          dateProcessed: "01102025",
          timeProcessed: "104950",
        },
        names: [
          {
            index: "N01",
            name: "MOHD HAFIJ KHAN",
            birthDate: "05081991",
            gender: "1",
          },
        ],
        ids: [
          {
            index: "I01",
            idType: "01",
            idNumber: "JUMPK7047G",
          },
          {
            index: "I02",
            idType: "06",
            idNumber: "XXXXXXXXXXXX",
          },
        ],
        telephones: [
          {
            index: "T01",
            telephoneNumber: "8502020946",
            telephoneType: "03",
          },
          {
            index: "T02",
            telephoneNumber: "8502020946",
            telephoneType: "01",
          },
        ],
        emails: [
          {
            index: "C01",
            emailID: "MDHAFIJKHAN43@GMAIL.COM",
          },
          {
            index: "C02",
            emailID: "HAFIJKHAN121@GMAIL.COM",
          },
        ],
        employment: [
          {
            index: "E01",
            accountType: "17",
            dateReported: "31012023",
            occupationCode: "04",
          },
        ],
        scores: [
          {
            scoreName: "CIBILTUSC3",
            scoreCardName: "08",
            scoreCardVersion: "10",
            scoreDate: "01102025",
            score: "00743",
            reasonCodes: [
              {
                reasonCodeName: "reasonCode1",
                reasonCodeValue: "01",
              },
            ],
          },
        ],
        addresses: [
          {
            index: "A01",
            line1: "SO SALIM KHAN MUSHALMANO KA MOHALLA MUND",
            line2: "OTA AMBER MUNDOTA JAIPUR RAJASTHAN 30370",
            stateCode: "08",
            pinCode: "303706",
            addressCategory: "04",
            dateReported: "31082024",
          },
          {
            index: "A02",
            line1: "S/O SALIM KHAN MUSHALMANO KA MOHALLA MUN",
            line2: "DOTA AMBER MUNDOTA JAIPUR RAJASTHAN 3037",
            line3: "6",
            stateCode: "08",
            pinCode: "303706",
            addressCategory: "02",
            dateReported: "31032024",
          },
          {
            index: "A03",
            line1: "MUSHALMANO KA MOHALLA MUNDOTA JAIPUR JAI",
            line2: "PUR RJ 303706",
            stateCode: "08",
            pinCode: "303706",
            addressCategory: "01",
            dateReported: "31082022",
          },
          {
            index: "A04",
            line1: "MUNDOTA JAIPUR MUSHALMANO KA MOHALLA",
            line2: "MUSHALMANO KA MOHALLA NEAR BY TEJAJI",
            line3: "MANDIR  JAIPUR",
            stateCode: "08",
            pinCode: "303706",
            addressCategory: "01",
            dateReported: "31032022",
          },
        ],
        accounts: [
          {
            index: "T001",
            memberShortName: "NOT DISCLOSED",
            accountType: "06",
            ownershipIndicator: 1,
            dateOpened: "27032024",
            dateClosed: "06122024",
            dateReported: "31122024",
            highCreditAmount: 21592,
            currentBalance: 0,
            paymentHistory: "000000000000000000000000000000",
            paymentStartDate: "01122024",
            paymentEndDate: "01032024",
            paymentTenure: 8,
            emiAmount: 2699,
            paymentFrequency: "03",
          },
          {
            index: "T002",
            memberShortName: "NOT DISCLOSED",
            accountType: "17",
            ownershipIndicator: 1,
            dateOpened: "29112022",
            dateClosed: "28012023",
            dateReported: "31012023",
            highCreditAmount: 264000,
            currentBalance: 0,
            paymentHistory: "000000000",
            paymentStartDate: "01012023",
            paymentEndDate: "01112022",
            paymentTenure: 48,
            paymentFrequency: "03",
          },
          {
            index: "T003",
            memberShortName: "NOT DISCLOSED",
            accountType: "69",
            ownershipIndicator: 1,
            dateOpened: "12072022",
            lastPaymentDate: "06122023",
            dateClosed: "27032024",
            dateReported: "31052024",
            highCreditAmount: 500,
            currentBalance: 0,
            paymentHistory:
              "000000000000000000000000000000000000000000000000000000000000000000",
            paymentStartDate: "01052024",
            paymentEndDate: "01082022",
          },
          {
            index: "T004",
            memberShortName: "NOT DISCLOSED",
            accountType: "06",
            ownershipIndicator: 1,
            dateOpened: "02032022",
            lastPaymentDate: "02112022",
            dateClosed: "02112022",
            dateReported: "30112022",
            highCreditAmount: 10490,
            currentBalance: 0,
            paymentHistory: "000000XXX000000000000000000",
            paymentStartDate: "01112022",
            paymentEndDate: "01032022",
            paymentFrequency: "03",
          },
        ],
        enquiries: [
          {
            index: "I001",
            enquiryDate: "25092024",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "10",
            enquiryAmount: 1000,
          },
          {
            index: "I002",
            enquiryDate: "18042024",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 100000,
          },
          {
            index: "I003",
            enquiryDate: "27032024",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 10000,
          },
          {
            index: "I004",
            enquiryDate: "10092023",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 25000,
          },
          {
            index: "I005",
            enquiryDate: "11082023",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 9000,
          },
          {
            index: "I006",
            enquiryDate: "23042023",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 25000,
          },
          {
            index: "I007",
            enquiryDate: "14022023",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 9000,
          },
          {
            index: "I008",
            enquiryDate: "21112022",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "17",
            enquiryAmount: 264000,
          },
          {
            index: "I009",
            enquiryDate: "27102022",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "17",
            enquiryAmount: 10000,
          },
          {
            index: "I010",
            enquiryDate: "25102022",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "05",
            enquiryAmount: 9000,
          },
          {
            index: "I011",
            enquiryDate: "06102022",
            memberShortName: "NOT DISCLOSED",
            enquiryPurpose: "17",
            enquiryAmount: 300000,
          },
        ],
        bureauCharacteristics: [
          {
            featureName: "BCPMTSTR",
            value: "NOBC",
          },
          {
            featureName: "CV18",
            value: "0",
          },
          {
            featureName: "ALL233",
            value: "0.00",
          },
          {
            featureName: "PAYMNT63",
            value: "23.88",
          },
          {
            featureName: "AT06S",
            value: "0",
          },
          {
            featureName: "AT36S",
            value: "2",
          },
          {
            featureName: "AT103S",
            value: "0",
          },
          {
            featureName: "BALMAG01",
            value: "1",
          },
          {
            featureName: "G503S",
            value: "56",
          },
          {
            featureName: "AT34A",
            value: "85",
          },
          {
            featureName: "G311S",
            value: "3.0",
          },
          {
            featureName: "DM247S",
            value: "0",
          },
          {
            featureName: "DM207S",
            value: "0",
          },
          {
            featureName: "DM217S",
            value: "3",
          },
          {
            featureName: "LEVERAGE_INDEX",
            value: "5.00",
          },
        ],
      },
    ],
    consumerSummaryData: {
      accountSummary: {
        totalAccounts: 4,
        overdueAccounts: 0,
        zeroBalanceAccounts: 4,
        highCreditAmount: 296582,
        currentBalance: 0,
        overdueBalance: 0,
        recentDateOpened: "27032024",
        oldestDateOpened: "02032022",
      },
      inquirySummary: {
        totalInquiry: 11,
        inquiryPast30Days: 0,
        inquiryPast12Months: 0,
        inquiryPast24Months: 3,
        recentInquiryDate: "25092024",
      },
    },
  };

  scoreValue: number = 0;
  scoreAmount: number = 0;

  @ViewChild("creditVisionChartRef")
  creditVisionChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild("personalLoanChartRef")
  personalLoanChartRef!: ElementRef<HTMLCanvasElement>;

  creditVisionChart: any;
  personalLoanChart: any;
  PurposeList: any[] = [];

  constructor(
    private dataSharingService: DataSharingService,
    private losService: LosService,
    private _commonfunctions: CommonFunctions
  ) { }

  ngOnInit(): void {
    this.dataSharingService.LOSHeaderTitle.next("Quick Loan Cibil Report");
    Chart.register(DoughnutController, ArcElement, Tooltip);

    // Initialize score value from demo data
    this.scoreValue =
      parseInt(this.cibilData?.consumerCreditData[0]?.scores[0]?.score) || null;
    this.scoreAmount = this.scoreValue;
    this.losService
      .GET_CRC_MASTER_BY_CRCAGENCY({
        Crc_Agency: "1",
        Is_Firm: 0,
      })
      .subscribe((res: any) => {
        this.PurposeList = res;
        console.log("Purpose list", this.PurposeList);
      });
  }

  ngAfterViewInit(): void {
    this.createCreditVisionChart();
    this.createPersonalLoanChart();
  }

  // Get value from bureau characteristics
  getBureauCharacteristicValue(featureName: string): string {
    const characteristic =
      this.cibilData?.consumerCreditData[0]?.bureauCharacteristics?.find(
        (char: any) => char.featureName === featureName
      );
    return characteristic ? characteristic.value : "N/A";
  }

  // Existing methods remain the same...
  getCRCThirdDetail() {
    $("#cibilReport").modal("show");
    $("#cibilReport").css("z-index", "1050");
  }

  onCloseCibilReport() {
    $("#cibilReport").modal("hide");
  }

  onDocsPrint(divName) {
    // Convert all canvases to images before printing
    const canvases = document.querySelectorAll(`#${divName} canvas`);
    canvases.forEach((canvas) => {
      const img = document.createElement("img");
      img.src = (canvas as HTMLCanvasElement).toDataURL("image/png");
      img.style.display = "block";
      img.style.margin = "0 auto";
      img.style.maxWidth = "220px";
      img.style.height = "auto";
      canvas.parentNode?.insertBefore(img, canvas);
      (canvas as HTMLElement).style.display = "none";
    });

    this._commonfunctions.PrintCibil(divName, "Cibil", new Date().getTime());

    setTimeout(() => {
      canvases.forEach((canvas) => {
        (canvas as HTMLElement).style.display = "block";
        if (
          canvas.previousSibling &&
          (canvas.previousSibling as Element).tagName === "IMG"
        ) {
          (canvas.previousSibling as Element).remove();
        }
      });
    }, 1000);
  }
  currentDate = new Date();

  generateControlNumber(): string {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
  }

  formatDate(dateString: string): string {
    if (!dateString || dateString.length !== 8) return "N/A";
    const day = dateString.substring(0, 2);
    const month = dateString.substring(2, 4);
    const year = dateString.substring(4, 8);
    return `${day}/${month}/${year}`;
  }

  getIdNumber(type: string): string {
    const id = this.cibilData?.consumerCreditData[0]?.ids?.find(
      (i: any) => i.idType === type
    );
    return id ? id.idNumber : "N/A";
  }

  getGenderText(genderCode: string): string {
    const genderMap: { [key: string]: string } = {
      "1": "Male",
      "2": "Female",
      "3": "Other",
    };
    return genderMap[genderCode] || "N/A";
  }

  formatAddress(address: any): string {
    if (!address) return "N/A";
    return `${address.line1}, ${address.line2}, ${address.line3}, ${address.stateCode} - ${address.pinCode}`;
  }

  formatCurrency(amount: number): string {
    if (amount === undefined || amount === null) return "₹0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  }

  getAccountTypeText(typeCode: string): string {
    const accountTypeMap: { [key: string]: string } = {
      "01": "Auto Loan",
      "02": "Housing Loan",
      "03": "Education Loan",
      "04": "Personal Loan",
      "05": "Credit Card",
      "06": "Gold Loan",
      "07": "Business Loan",
      "08": "Agriculture Loan",
      "09": "Consumer Durable Loan",
      "10": "Two Wheeler Loan",
      "11": "Other",
    };
    return accountTypeMap[typeCode] || "Other";
  }

  getEnquiryPurposeText(purposeCode: string): string {
    const enquiryPurposeMap: { [key: string]: string } = {
      "01": "Auto Loan",
      "02": "Housing Loan",
      "03": "Personal Loan",
      "04": "Credit Card",
      "05": "Consumer Durable Loan",
      "06": "Education Loan",
      "07": "Business Loan",
      "08": "Gold Loan",
      "09": "Two Wheeler Loan",
      "10": "Other",
    };
    return enquiryPurposeMap[purposeCode] || "Other";
  }

  // Chart methods
  createGaugeChart(ctx: CanvasRenderingContext2D, score: number) {
    const min = 300;
    const max = 900;
    const getScoreColor = this.getScoreColor;

    const chart = new Chart(ctx, {
      type: "doughnut",
      data: {
        datasets: [
          { data: [1], backgroundColor: ["rgba(0,0,0,0)"], borderWidth: 0 },
        ],
      },
      options: {
        rotation: Math.PI,
        circumference: Math.PI,
        cutout: "70%",
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        responsive: true,
        maintainAspectRatio: false,
      },
      plugins: [
        {
          id: "customGauge",
          afterDraw(chart) {
            const {
              ctx,
              chartArea: { width, height },
            } = chart;
            const cx = width / 2;
            const cy = height * 0.95;
            const value = Math.max(min, Math.min(score, max));
            const percent = (value - min) / (max - min);
            const radius = Math.min(width / 2.2, height / 1.3);

            // Draw gray arc
            ctx.save();
            ctx.beginPath();
            ctx.strokeStyle = "#ecf0f1";
            ctx.lineWidth = radius * 0.22;
            ctx.arc(cx, cy, radius, Math.PI, 2 * Math.PI, false);
            ctx.stroke();
            ctx.restore();

            // Draw colored arc
            ctx.save();
            ctx.beginPath();
            ctx.strokeStyle = getScoreColor(value);
            ctx.lineWidth = radius * 0.22;
            ctx.arc(
              cx,
              cy,
              radius,
              Math.PI,
              Math.PI + Math.PI * percent,
              false
            );
            ctx.stroke();
            ctx.restore();

            // Draw needle
            const needleAngle = Math.PI + Math.PI * percent;
            const needleLength = radius * 1.08;
            const tipX = cx + needleLength * Math.cos(needleAngle);
            const tipY = cy + needleLength * Math.sin(needleAngle);
            const baseRadius = radius * 0.85;
            const baseLeftX =
              cx + baseRadius * Math.cos(needleAngle - Math.PI / 120);
            const baseLeftY =
              cy + baseRadius * Math.sin(needleAngle - Math.PI / 120);
            const baseRightX =
              cx + baseRadius * Math.cos(needleAngle + Math.PI / 120);
            const baseRightY =
              cy + baseRadius * Math.sin(needleAngle + Math.PI / 120);

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(tipX, tipY);
            ctx.lineTo(baseLeftX, baseLeftY);
            ctx.lineTo(baseRightX, baseRightY);
            ctx.closePath();
            ctx.fillStyle = "#222";
            ctx.fill();
            ctx.restore();

            // Score text
            ctx.font = "bold 38px Arial";
            ctx.fillStyle = "#111";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(value.toString(), cx, cy - radius / 2.8);

            // Scale labels
            ctx.font = "18px Arial";
            ctx.fillStyle = "#aaa";
            ctx.textAlign = "left";
            ctx.fillText("300", cx - radius, cy + 18);
            ctx.textAlign = "right";
            ctx.fillText("900", cx + radius, cy + 18);
          },
        },
      ],
    });

    return chart;
  }
  findItemById(code): void {
    if (this.PurposeList.find((item) => item.Code === code)) {
      return this.PurposeList.find((item) => item.Code === code).Value;
    } else null;
  }

  createCreditVisionChart() {
    if (!this.creditVisionChartRef?.nativeElement) return;
    const ctx = this.creditVisionChartRef.nativeElement.getContext("2d");
    if (!ctx) return;

    if (this.creditVisionChart) this.creditVisionChart.destroy();
    this.creditVisionChart = this.createGaugeChart(
      ctx,
      this.cibilData?.consumerCreditData[0]?.scores[0]?.score
    );
  }

  createPersonalLoanChart() {
    if (!this.personalLoanChartRef?.nativeElement) return;
    const ctx = this.personalLoanChartRef.nativeElement.getContext("2d");
    if (!ctx) return;

    if (this.personalLoanChart) this.personalLoanChart.destroy();
    this.personalLoanChart = this.createGaugeChart(
      ctx,
      this.calculatePersonalLoanScore()
    );
  }

  getScoreColor(score: number): string {
    if (score >= 750) return "#27ae60";
    if (score >= 700) return "#2ecc71";
    if (score >= 650) return "#ffe135";
    if (score >= 600) return "#daa520";
    return "#c0392b";
  }

  calculatePersonalLoanScore(): number {
    return 665;
  }

  getScoreRating(score: number): string {
    if (score >= 750) return "Excellent";
    if (score >= 700) return "Good";
    if (score >= 650) return "Fair";
    if (score >= 600) return "Poor";
    return "Very Poor";
  }

  // Risk scale methods
  getRiskPercentage(
    value: number,
    lowRiskValue: number,
    highRiskValue: number
  ): number {
    if (lowRiskValue < highRiskValue) {
      const range = highRiskValue - lowRiskValue;
      return Math.max(0, Math.min(100, ((value - lowRiskValue) / range) * 100));
    } else {
      const range = lowRiskValue - highRiskValue;
      return Math.max(0, Math.min(100, ((lowRiskValue - value) / range) * 100));
    }
  }

  getRiskColor(
    value: number,
    lowRiskValue: number,
    highRiskValue: number
  ): string {
    const percentage = this.getRiskPercentage(
      value,
      lowRiskValue,
      highRiskValue
    );
    if (percentage <= 33) return "low-risk";
    if (percentage <= 66) return "medium-risk";
    return "high-risk";
  }

  ngOnDestroy() {
    if (this.creditVisionChart) this.creditVisionChart.destroy();
    if (this.personalLoanChart) this.personalLoanChart.destroy();
  }
  // ...existing code...
  months: string[] = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  // Helper to parse payment history into a map: {year: {month: value}}
  getDPDMatrix(account: any): { [year: string]: { [month: string]: string } } {
    if (!account?.paymentHistory || !account?.paymentStartDate) return {};
    const matrix: { [year: string]: { [month: string]: string } } = {};
    let startDate = this.parseDate(account.paymentStartDate); // returns {year, month}
    for (let i = 0; i < account.paymentHistory.length / 3; i++) {
      const value = account.paymentHistory.substr(i * 3, 3);
      const year = startDate.year;
      const monthIdx = startDate.month - 1; // 0-based
      const monthName = this.months[monthIdx];
      if (!matrix[year]) matrix[year] = {};
      matrix[year][monthName] = value;
      // Move to previous month
      startDate.month--;
      if (startDate.month < 1) {
        startDate.month = 12;
        startDate.year--;
      }
    }
    return matrix;
  }

  PMTFREQ(paymentFrequency) {
    if (paymentFrequency == "01") return "Weekly";
    if (paymentFrequency == "02") return "ByWeekly";
    if (paymentFrequency == "03") return "Monthly";
    if (paymentFrequency == "04") return "Quarterly";
    if (paymentFrequency == "06") return "Daily";
    if (paymentFrequency == "07") return "HalfYearly";
    if (paymentFrequency == "08") return "Yearly";
    if (paymentFrequency == "09") return "STEP_EMI";
  }
  // Helper to get all years in payment history
  getDPDYears(account: any): string[] {
    const matrix = this.getDPDMatrix(account);
    return Object.keys(matrix).sort((a, b) => +b - +a); // Descending
  }

  // Helper to get value for a year/month
  getDPDValue(account: any, year: string, month: string): string {
    const matrix = this.getDPDMatrix(account);
    return matrix[year]?.[month] || "";
  }

  // Parse date string "DDMMYYYY" to {year, month}
  parseDate(dateStr: string): { year: number; month: number } {
    if (!dateStr || dateStr.length !== 8) return { year: 0, month: 0 };
    return {
      year: parseInt(dateStr.substring(4, 8), 10),
      month: parseInt(dateStr.substring(2, 4), 10),
    };
  }
  // ...existing code...
}
